module.exports = __webpack_public_path__ + "img/coudelaria-veiga-01.a6aa04fd.png";